import React from 'react';
import './AncServiceModal.css';
import { Modal, Tooltip } from 'react-bootstrap';
import Button from '@components/common/Button';
import Clock from '../../../../../../src/assets/svg_main/clock-01.svg';
import InfoBar from '@components/common/InfoBars';
import TooltipComponent from '@components/common/TooltipComponent';
import Spinner from '@components/common/Spinner';

interface ErrorObject {
  showError: boolean;
  errorMessage: string;
  errorField: string;
  isDisable: boolean;
}

interface AncServiceModalProps {
  showModal: boolean;
  onClose: () => void;
  modalTitle: string;
  modalSubTitle:string
  content:any;
  handleItemClick: (item: string) => void;
  handleBack:(modalTitle:string) => void;
  errors?: ErrorObject[];
  loading?: boolean;
}


const AncServiceModal = (props:AncServiceModalProps) => {
  const { 
    showModal,
    onClose,
    modalTitle,
    modalSubTitle,
    content,
    handleItemClick,
    handleBack,
    errors,
    loading = false,
   } = props;

  const getErrorForField = (field: string) => {
    return errors?.find(error => error.errorField === field);
  };

  return (
    <div className="anc-service-modal">
      <Modal
        show={showModal}
        onHide={onClose}
        dialogClassName={'anc-service-modal'}
        centered={true}
        backdrop = "static"
      >
        <Modal.Body>
          <div className="anc-service-modal-body-header">
            <div 
              className="modal-body-back"
              onClick={() => handleBack(modalTitle)}>
            <i className="bi bi-arrow-left"></i>
            </div>
            <div className="modal-body-discard" onClick={onClose}>
            <i className="bi bi-x"></i>
            </div>
          </div>
          { !loading ?
          <div className="anc-service-modal-title">
            <h1>{modalTitle}</h1>
            <h3>{modalSubTitle}</h3>

            <div className="anc-service-modal-info">
              {content.map((item:any, index:number)=>{
                const error = getErrorForField(item);
                const currIndex = index + 1;
                return(
                  <div key={item}>
                      <div 
                      key= {item}
                      className={`anc-service-modal-data ${error?.isDisable ? 'anc-service-disabled' : '' }`}
                      onClick={!error?.isDisable ? () => handleItemClick(item) : undefined} 
                    >
                      <div className='anc-service-modal-icon' >
                        <span><Clock/></span>
                        <p>{`${currIndex}. ${item}`}</p>
                      </div>
                      <span>+</span>
                    </div>
                    {error?.showError && <InfoBar
                      variant="danger"
                      message={error.errorMessage}
                      className="input_field_class"
                    />}
                  </div>
                )
              })}
            </div>
          </div> 
          : <div className="anc-service-modal-spinner">
            <Spinner/>
            <h6>Loading Services</h6>
          </div>
          }
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default AncServiceModal